import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

@Component({
  selector: 'app-no-results',
  templateUrl: './no-results.component.html',
  styleUrls: ['./no-results.component.scss'],
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class NoResultsComponent {
  @Input() noRecordFound = 'No options matching your search';
  public profileImagePath ='assets/images/no-results.png';

  openExternalScreen() {
    const url = `${window.location.origin}/slt/apps/external-web/#/create-rate-request`;
    window.open(url, '_blank', 'noopener,noreferrer');
  }



}
